import { Col, Container, Row } from "reactstrap";
import Description from "./Description";
import { FaUniversity } from "react-icons/fa";
import { MdAccountTree } from "react-icons/md";
import { HiUserGroup } from "react-icons/hi2";
import { FaPen } from "react-icons/fa";

const Why = () => {

  const listWhy = [
    { icon:<FaUniversity className="why-icon" />, title: "Kampus di Tiga Kota Ikonik Irlandia", body: "Belajar di Dublin, Cork, atau Limerick dengan lingkungan energik, kreatif, dan penuh kesempatan kerja sambil kuliah."},
    { icon:<MdAccountTree className="why-icon" />, title: "Pilihan Program Luas & Fleksibel", body: "Dari bisnis, IT, media, psikologi, hukum, sampai film & design — kamu bisa pilih jurusan yang sesuai passion dan tujuan karier."},
    { icon:<HiUserGroup className="why-icon" />, title: "Komunitas Internasional & Support Services", body: "Campus life ramai, support service lengkap, plus karier service yang bantu kamu siap kerja global."},
    { icon:<FaPen className="why-icon" />, title: "Belajar di Pusat Eropa + Akses Job Market", body: "Irlandia merupakan negara yang strategis buat belajar & kerja paruh waktu sambil kuliah (asalkan sesuai visa)."},
  ]

  return (
    <section className="section" id="why">
      <Container>
        <Row className="why-wrapper flex-lg-row gap-4">
        <Description />
          <Col>
            <img 
              src="assets/images/img-why.webp" 
              alt="melbourne-polytechnic-sign-and-students-of-melbourne-polytechnic's" 
              className="img-fluid"
            />          
          </Col>
          <Col>
            <h1 className="mb-3"><b>4 Keunggulan Kampus Griffith College Ireland</b></h1>
            <div className="mb-3 mb-md-5">
              {listWhy.map((item, id) => (
                <div key={id} className="d-flex text-start gap-2">
                  <div>
                    {item.icon}         
                  </div>
                  <div>
                      <span className="fw-bold">{item.title}</span>
                      <p className="fw-normal">{item.body}</p>
                  </div>                
                </div>
              ))}
            </div>
          </Col>
        </Row>
      </Container>      
    </section>
  );
};

export default Why;